<template>
	<div class="">
		<base-page-heading
			title="Lister Items"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="productcategoryShow"
					type="submit"
					size="md"
					variant="secondary"
					@click="showModal"
				>
					<i class="fa fa-fw fa-plus" /> 	Create new
				</b-button>
			</template>
		</base-page-heading>

		<div class="row">
			<ProductCategoriesTable @routeProductCategory="routeProductCategory" />
		</div>
	</div>
</template>
